import { Injectable } from '@angular/core';
import { EchoService } from './echo.service';

@Injectable({
  providedIn: 'root'
})
export class TimerService {

  constructor(private echoService: EchoService) {}

  listenForTimerStart(callback: (data: any) => void) {
    this.echoService.echo.channel('timers').listen('TimerStarted', callback);
  }
  listenForTimerPause(callback: (data: any) => void) {
    this.echoService.echo.channel('pause-timer').listen('TimerPaused', callback);
  }
  listenForMessage(callback: (data: any) => void) {
    this.echoService.echo.channel('message').listen('Message', callback);
  }
  listenForFlashBlackout(callback: (data: any) => void) {
    this.echoService.echo.channel('flash-blackout').listen('FlashBlackout', callback);
  }
  listenForTimerFlashBlackout(callback: (data: any) => void) {
    this.echoService.echo.channel('timer-flash-blackout').listen('TimerFlashBlackout', callback);
  }
  listenForFocusMsg(callback: (data: any) => void) {
    this.echoService.echo.channel('focus-msg').listen('FocusMsg', callback);
  }
  listenForDevices(callback: (data: any) => void) {
    this.echoService.echo.channel('track-devices').listen('TrackDevice', callback);
  }
  listenForDevicesReload(callback: (data: any) => void) {
    this.echoService.echo.channel('reload-device').listen('ForceReloadDevice', callback);
  }
  listenForAddMinusTime(callback: (data: any) => void) {
    this.echoService.echo.channel('add-minus-time').listen('AddMinusTime', callback);
  }
  listenForTotalBlackout(callback: (data: any) => void) {
    this.echoService.echo.channel('total-blackout').listen('TotalBlackout', callback);
  }
  listenForTimerReset(callback: (data: any) => void) {
    this.echoService.echo.channel('reset-timer').listen('TimerReset', callback);
  }
}
